import React, { useContext, useState, useEffect } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@material-ui/core";

import { Close, ExpandMore } from "@material-ui/icons";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import { HeaderModal, CloseAtRight } from "../styles/Emissao";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

import { findNotas } from "../../../../repositories/qerpapi/erp/nf/v1/NotafiscalRepository";
import { notify } from "../../../../utils/notify";
import MaskService from "../../../../utils/mask/maskService";
import TableDefault from "../../../../components/grid/TableDefault";
import { HeaderAccordion, HeaderVendaPagamentos } from "../styles/Nfe";

const ModalVerVendas = ({ modalOpen, setModalOpen, nfe, setMainLoading }) => {
  const { queryParams } = useContext(QueryParamsContext);
  const [sales, setSales] = useState([]);

  useEffect(() => {
    (async () => {
      setMainLoading(true);
      const callback = await findNotas(
        queryParams.empresa_cnpj,
        nfe,
        "vendas,vendas.cliente,vendas.situacao,vendas.vendedor,vendas.vendasitens.estoque.produto.fornecedor,vendas.vendasformaspagtos.tipopagtos,vendas.vendasformaspagtos.formapagto"
      );

      if (callback.success) setSales(callback.data.vendas.reverse());
      else {
        setMainLoading(false);
        return notify("Erro ao bucar dados de venda vinculados à NFe");
      }
      setMainLoading(false);
    })();
  }, [nfe, queryParams.empresa_cnpj, setMainLoading, setModalOpen]);

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={modalOpen && !!sales.length}
      onClose={handleClose}
      aria-labelledby="dialog-email-nfe"
    >
      <HeaderModal>
        <DialogTitle id="dialog-email-nfe">
          <Grid container wrap="nowrap">
            <Chip label="Ver vendas" bgcolor="primary" textcolor="white" />
            <CloseAtRight>
              <Btn
                onClick={handleClose}
                bgcolor="red"
                hovercolor="darkred"
                startIcon={<Close />}
              />
            </CloseAtRight>
          </Grid>
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Accordions sales={sales} />
      </DialogContent>
    </Dialog>
  );
};

const Accordions = ({ sales }) => {
  return (
    <>
      {sales.map((current) => (
        <AccordionBody sale={current} key={current.id} />
      ))}
    </>
  );
};

const AccordionBody = ({ sale }) => {
  const [expanded, setExpanded] = useState(false);

  const columnsTable = [
    {
      id: "numero_item",
      label: "Seq.",
    },
    {
      id: "codigo",
      label: "Código",
      format: (current) =>
        current.estoque.codigobarras ? current.estoque.codigobarras : "",
    },
    {
      id: "fde_numeroproduto",
      label: "Ref. Fornecedor",
    },
    {
      id: "descricao",
      label: "Descrição",
      format: (current) =>
        current.estoque.produto.descricao
          ? current.estoque.produto.descricao
          : "",
    },
    {
      id: "unidade",
      label: "UN.",
    },
    {
      id: "fator_conversao",
      label: "Fator",
      format: (current) =>
        current.fator_conversao
          ? handleFloatValue(current.fator_conversao)
          : "",
    },
    {
      id: "qtde",
      label: "Qtde.",
      format: (current) => (current.qtde ? handleFloatValue(current.qtde) : ""),
    },
    {
      id: "precovenda",
      label: "Preço venda",
      format: (current) =>
        current.estoque.precovenda
          ? handleFloatValue(current.estoque.precovenda)
          : "",
    },
    {
      id: "desconto",
      label: "Desconto Item Valor",
      format: (current) =>
        current.estoque.desconto
          ? handleFloatValue(current.estoque.desconto)
          : "",
    },
    {
      id: "desconto_porc",
      label: "Desconto Item Porc",
      format: (current) =>
        current.estoque.desconto_porc
          ? `${handleFloatValue(current.estoque.desconto_porc)} %`
          : "",
    },
    {
      id: "desconto_porcentagem_geral",
      label: "Desconto Geral Valor",
      format: (current) =>
        current.desconto_porcentagem_geral
          ? handleFloatValue(current.desconto_porcentagem_geral)
          : "",
    },
    {
      id: "descontoporcoriginal",
      label: "Desconto Geral Porc",
      format: (current) =>
        current.descontoporcoriginal
          ? `${handleFloatValue(current.descontoporcoriginal)} %`
          : "",
    },
    {
      id: "precounitario",
      label: "Preço",
      format: (current) =>
        current.precounitario ? handleFloatValue(current.precounitario) : "",
    },
    {
      id: "precototal",
      label: "Total",
      format: (current) =>
        current.precototal ? handleFloatValue(current.precototal) : "",
    },
  ];

  const handleFloatValue = (value) =>
    parseFloat(value).toFixed(2).replace(".", ",");

  const handleChangeOpenAcordion = (accordion) => {
    setExpanded((current) => ({
      ...current,
      [accordion]: !current[accordion],
    }));
  };

  return (
    <Accordion
      expanded={expanded.general || false}
      onChange={() => handleChangeOpenAcordion("general")}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <HeaderAccordion>
          <Grid container>
            <Grid item xs={12}>
              <Chip
                bgcolor={!expanded.general ? "default" : "primary"}
                textcolor={!expanded.general ? "default" : "white"}
                label={`Dados da venda nº ${sale.numvenda}`}
              />
            </Grid>
          </Grid>
        </HeaderAccordion>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            {sale.numvenda && (
              <Typography variant="subtitle1">{`Número da venda: ${sale.numvenda}`}</Typography>
            )}
            {sale.situacao && (
              <Typography variant="subtitle1">{`Situação: ${sale.situacao.descricao}`}</Typography>
            )}
            {sale.cliente && (
              <Typography variant="subtitle1">{`Cliente: ${sale.cliente.apelido}`}</Typography>
            )}
            {sale.data && (
              <Typography variant="subtitle1">{`Data: ${MaskService.dateYmdToDmy(
                sale.data
              )}`}</Typography>
            )}
          </Grid>

          <Grid item xs={12} md={4}>
            {sale.subtotal && (
              <Typography variant="subtitle1">{`Subtotal: ${sale.subtotal}`}</Typography>
            )}
            {sale.totaldesconto && (
              <Typography variant="subtitle1">{`Desconto: ${sale.totaldesconto}`}</Typography>
            )}
            {sale.totalfrete && (
              <Typography variant="subtitle1">{`Frete: ${sale.totalfrete}`}</Typography>
            )}
            {sale.totalgeral && (
              <Typography variant="subtitle1">{`Total: ${sale.totalgeral}`}</Typography>
            )}
          </Grid>

          <Grid item xs={12} md={4}>
            {sale.statusvenda && (
              <Typography variant="subtitle1">{`Tipo: ${sale.statusvenda}`}</Typography>
            )}
            {sale.vendedor && (
              <Typography variant="subtitle1">{`Vendedor: ${sale.vendedor.apelido}`}</Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <TableDefault
              columns={columnsTable}
              values={sale.vendasitens}
              rowsPerPage={10}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <HeaderVendaPagamentos>
              <Chip
                bgcolor={"secondary"}
                textcolor={"default"}
                label={"Dados de pagamento"}
              />
              <Grid container>
                <Grid item xs={8}>
                  <Typography>Tipo</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography>Valor</Typography>
                </Grid>
              </Grid>
              {sale.vendasformaspagtos.map((pagamento) => {
                return (
                  <Grid container key={pagamento.id}>
                    <Grid item xs={8}>
                      {pagamento.tipopagtos && pagamento.formapagto && (
                        <Typography variant="subtitle1">{`${pagamento.tipopagtos.descricao} ${pagamento.formapagto.descricao}`}</Typography>
                      )}
                    </Grid>

                    <Grid item xs={4}>
                      {pagamento.tipopagtos && pagamento.formapagto && (
                        <Typography variant="subtitle1">{`${pagamento.valor}`}</Typography>
                      )}
                    </Grid>
                  </Grid>
                );
              })}
            </HeaderVendaPagamentos>
          </Grid>

          <Grid item xs={12} md={6}>
            <HeaderVendaPagamentos>
              <Chip
                bgcolor={"secondary"}
                textcolor={"default"}
                label={"Observações"}
              />
              <Grid container>
                <Grid item xs={12}>
                  <Typography variant="subtitle1">{sale.observacao}</Typography>
                </Grid>
              </Grid>
            </HeaderVendaPagamentos>
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default ModalVerVendas;
